import data from './data'
import methods from './methods'

export default {
  data,
  methods,

  resourcePath: 'v1/professional/agendas/agendas/'
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/active-agenda/resources/index.js